import Color from 'colorjs.io'
import { useMemo } from 'react'

import { cn } from '@/lib/utils'

interface Props {
  color?: string
  checked: boolean
  label: string
  onClick?: () => void
}

const CustomToggleButton = ({ color = '#27C226', checked, label, onClick }: Props) => {
  const currentBg = useMemo(() => {
    if (color && !color.startsWith('#')) {
      color = `#${color}`
    } else if (!color) {
      color = '#27C226'
    }
    return color
  }, [color])

  const textColor = useMemo(() => {
    const white = new Color('white')
    const black = new Color('black')
    const contrastWhite = Color.contrastLstar(new Color(currentBg), white)
    const contrastBlack = Color.contrastLstar(new Color(currentBg), black)
    if (contrastWhite > contrastBlack) {
      return 'white'
    } else {
      return 'black'
    }
  }, [color])

  return (
    <div
      className={cn(
        'relative inline-flex cursor-pointer select-none items-center overflow-hidden text-center align-bottom',
        'rounded-md px-4 py-3 text-base ',
        'border transition duration-200 ease-in-out',
        {
          'border-gray-300 bg-white text-gray-700 hover:border-gray-300 hover:bg-gray-100 hover:text-gray-700':
            !checked,
          'bg-primary border-primary hover:bg-primary-dark hover:border-primary-dark text-white':
            checked,
        }
      )}
      style={{
        backgroundColor: checked ? currentBg : 'white',
        borderColor: currentBg,
        color: checked ? textColor : currentBg,
      }}
      onClick={onClick}
    >
      <span>{label}</span>
    </div>
  )
}
export default CustomToggleButton
